export class SubmitFeedbackRequest {
    FeedbackCategory: string;
    CustomerAccountID: string;
    Comment: string;
    ActivePage: string;
    ScreenSize: string;
    Browser: string;
}
